<div class="d-flex px-2 w-100 justify-content-center info-legal">
    <div class="columnn w-50">
        <div class="row">
            <h2 class="w-100 my-4">{{data.tituloWeb}}</h2>
        </div>
        <div>
            <div class="row">
                <!-- <p *ngFor="let parr of parrafos" class="w-100 subtitle">{{parr}}</p> -->
                <div [innerHTML]="parrafos"></div>
            </div>
        </div>
    </div>
</div>